import { render, staticRenderFns } from "./CreateFilterModal.vue?vue&type=template&id=4b807aa6&"
import script from "./CreateFilterModal.vue?vue&type=script&lang=js&"
export * from "./CreateFilterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b807aa6')) {
      api.createRecord('4b807aa6', component.options)
    } else {
      api.reload('4b807aa6', component.options)
    }
    module.hot.accept("./CreateFilterModal.vue?vue&type=template&id=4b807aa6&", function () {
      api.rerender('4b807aa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Email/CreateFilterModal.vue"
export default component.exports